<script setup lang="ts">
import {
  showUserServiceDialogue,
  showVIPDialogue,
} from "@/components/Dialogues/useData/useDialogues";
import { sendMsg, setType } from "@/views/Home/useData/module/chat";
import { ref, reactive, computed, Reactive, watch } from "vue";
import { ElMessage } from "element-plus";
import { chatStatus } from "@/views/Home/useData/module/chat";
import { isCompactMode } from "@/data/pubilc";
import {
  uploadCurFile,
  inputForm,
} from "@/components/Dialogues/useData/useInputBar";
import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";
import { openLoginDialog } from "@/components/Dialogues/useData/login";

const { isLogin, isVip } = storeToRefs(publicStore());

const isReplying = computed(() => {
  return chatStatus.isReplying;
});

const preSendMsg = async () => {
  if (isUploadingFile.value) {
    ElMessage.warning("请等待文件上传完毕");
    return;
  }
  inputForm.inputValue = inputForm.inputValue.trim();
  const text = inputForm.inputValue;
  if (text === "") {
    ElMessage.warning("请输入内容");
    return;
  }

  if (isReplying.value) {
    return;
  }

  if (!isLogin.value) {
    ElMessage.warning("请登录后使用");

    openLoginDialog();
    return;
  }

  if (!isVip.value) {
    showVIPDialogue.value = true;
    return;
  }

  //检查类型
  const type = inputForm.r1 ? "R1" : "deep-seek-v3";
  setType(type);

  let options = {
    chatOption: {
      use_internet: inputForm.network,
    },
  };

  if (inputForm.network) {
    options.chatOption["auto_user_want"] = true;
    options.chatOption["user_want"] = 1;
  }

  if (referenceFile.fileUrl) {
    options = {
      use_internet: inputForm.network,
      url: referenceFile.fileUrl,
      fileInfo: {
        url: referenceFile.fileUrl,
        name: referenceFile.fileName,
      },
      chatOption: {
        user_want: 8,
      },
    };
  }

  await sendMsg(text, options);

  inputForm.inputValue = "";
  clearFile();
};

const referenceFile: Reactive<any> = reactive({
  fileUrl: "",
  fileName: "",
});

const isUploadingFile = ref(false);

const onChange = async (data: any) => {
  if (data.status !== "ready") return;
  if (!isLogin.value) {
    ElMessage.warning("请登录后使用");
    openLoginDialog();
    return;
  }
  isUploadingFile.value = true;
  console.log("Received data", data);
  const rawFile: any = data.raw;
  const typeList = ["image/jpg", "image/png", "image/jpeg"];
  if (!typeList.includes(rawFile.type))
    return ElMessage.error("只支持jpg/png文件格式");
  else if (rawFile.size / 1024 / 1024 > 10)
    return ElMessage.error(`文件大小不能超过10MB!`);
  let url = URL.createObjectURL(rawFile);

  const fileInfo = {
    file: rawFile,
    name: rawFile.name,
    size: rawFile.size,
  };
  fileInfo.file["path"] = url;
  const res: any = await uploadCurFile(fileInfo);
  referenceFile.fileUrl = res;
  referenceFile.fileName = fileInfo.name;
  isUploadingFile.value = false;
};

const clearFile = () => {
  referenceFile.fileUrl = "";
  referenceFile.fileName = "";
  isUploadingFile.value = false;
};

const changeToR1 = () => {
  inputForm.r1 = !inputForm.r1;
  clearFile();
};
</script>

<template>
  <div
    class="input-base"
    :class="{
      'file-content': referenceFile.fileUrl,
    }"
  >
    <div class="file-display" v-if="referenceFile.fileUrl">
      <div class="img-box">
        <el-image
          style="width: 60px; height: 60px"
          :src="referenceFile.fileUrl"
          fit="cover"
        />
        <div class="close-btn" @click="clearFile">
          <el-icon :size="16"><CircleCloseFilled /></el-icon>
        </div>
      </div>
    </div>
    <textarea
      v-model="inputForm.inputValue"
      class="text-area"
      name=""
      id=""
      rows="10"
      @keyup.enter="preSendMsg"
      placeholder="在这里输入您的问题开始和AI对话"
    ></textarea>
    <div class="menu-bar">
      <div
        class="left"
        :class="{
          'compact-gap': isCompactMode,
        }"
      >
        <el-tooltip
          class="box-item"
          effect="dark"
          content="调用新模型DeepSeek-R1，解决推理问题"
          placement="left"
          :disabled="isCompactMode"
        >
          <div
            class="btn"
            :class="{ 'dis-selected': !inputForm.r1 }"
            @click="changeToR1"
          >
            深度思考(R1)
          </div>
        </el-tooltip>
        <el-tooltip
          class="box-item"
          effect="dark"
          content="按需搜索网页"
          placement="right"
          :disabled="isCompactMode"
        >
          <div
            class="btn"
            :class="{ 'dis-selected': !inputForm.network }"
            @click="inputForm.network = !inputForm.network"
          >
            互联网搜索
          </div>
        </el-tooltip>
      </div>
      <div class="right">
        <el-upload
          :show-file-list="false"
          :auto-upload="false"
          :on-change="onChange"
          accept=".png,.jpg,.jpeg"
        >
          <el-tooltip
            class="box-item"
            effect="dark"
            content="上传图片，仅识别文字"
            placement="bottom"
            v-if="!inputForm.r1"
            :disabled="isCompactMode"
          >
            <div class="file">
              <el-icon :color="`black`" :size="24"><Paperclip /></el-icon>
            </div>
          </el-tooltip>
        </el-upload>

        <el-tooltip
          class="box-item"
          effect="dark"
          content="提交"
          placement="right"
          :disabled="isCompactMode"
        >
          <div class="send-btn" @click="preSendMsg">
            <el-icon :color="`white`" :size="24"><Top /></el-icon>
          </div>
        </el-tooltip>
      </div>
    </div>
  </div>
  <div class="des">
    <div class="text">内容由 AI 生成，请仔细甄别</div>
    <div class="text btn" @click="showUserServiceDialogue = true">关于我们</div>
  </div>
</template>

<style lang="scss" scoped>
.input-base {
  width: 100%;
  height: 142px;
  padding: 8px;

  border-radius: 24px;
  border: 1px solid #ddd;
  background-color: #f3f4f6;
  display: flex;
  flex-direction: column;

  .file-display {
    width: 100%;
    height: 60px;
    padding-left: 10px;
    .img-box {
      width: 60px;
      height: 60px;
      border-radius: 4px;
      overflow: hidden;
      position: relative;

      .close-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        width: 20px;
        height: 20px;
        top: 0;
        right: 0;
        cursor: pointer;
      }
    }
  }

  .text-area {
    padding: 12px;
    font-size: 16px;
    flex: 1;
    outline: none;
    border: none;
    resize: none;
    background-color: transparent;
  }

  .menu-bar {
    width: 100%;
    padding: 8px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .compact-gap {
      gap: 4px !important;
    }
    .left {
      display: flex;
      align-items: center;
      gap: 12px;
      .btn {
        display: flex;
        align-items: center;
        padding: 4px 8px;
        font-size: 12px;
        height: 28px;
        border-radius: 14px;
        background-color: #dbeafe;
        color: #4d6bfe;
        border: 1px solid #4d6bfe;
        cursor: pointer;
        &:hover {
          background-color: #dbeafe88;
        }
      }

      .dis-selected {
        background-color: white;
        color: #4c4c4c;
        border: 1px solid #dddddd;
      }
    }

    .right {
      display: flex;
      align-items: center;
      gap: 8px;

      .file {
        width: 36px;
        height: 36px;
        border-radius: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &:hover {
          background-color: #4d6bfe11;
        }
      }

      .send-btn {
        width: 36px;
        height: 36px;
        border-radius: 18px;
        background-color: #4d6bfe;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &:hover {
          background-color: #4d6bfe55;
        }
      }
    }
  }
}

.file-content {
  height: 200px;
}

.des {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  .text {
    font-size: 14px;
  }

  .btn {
    color: #4d6bfe;
    cursor: pointer;
  }
}
</style>
